module.exports = __webpack_public_path__ + "media/images/arr_black-544594f345dbca43f0c65bb7fc609303.svg";